'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SunCloudyIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.25 10.75H21.25M13.25 3.75V2.75M18.1997 5.80025L18.9069 5.09315M7.59375 5.09315L8.3009 5.80026M9.70267 8.89989C10.2519 8.97014 10.7787 9.11304 11.273 9.31871C12.7092 9.91622 13.872 11.0435 14.5203 12.4583C15.1517 12.1333 15.867 11.95 16.625 11.95C16.7718 11.95 16.9171 11.9569 17.0604 11.9703M9.70267 8.89989C9.44529 8.86697 9.18295 8.85 8.91667 8.85C5.51091 8.85 2.75 11.6258 2.75 15.05C2.75 18.4742 5.51091 21.25 8.91667 21.25H16.625C19.1793 21.25 21.25 19.1681 21.25 16.6C21.25 14.6435 20.0481 12.9692 18.3462 12.2827C17.9426 12.1199 17.5109 12.0126 17.0604 11.9703M9.70267 8.89989C10.3705 7.62211 11.7084 6.75 13.25 6.75C15.4591 6.75 17.25 8.54086 17.25 10.75C17.25 11.1756 17.1835 11.5856 17.0604 11.9703",
        stroke: "currentColor",
        strokeLinecap: "square"
      }
    )
  }
);
const VpSunCloudyIcon = forwardRef(SunCloudyIcon);

export { VpSunCloudyIcon as default };
